<script setup lang="ts">
import { useStoreInfo } from '@/utils/useStoreInfo'
import { watchersHeader } from '@/utils/watchers/header/watchersHeader'
import { dataLoaded } from '@/event/dataLoaded'
import { defineAsyncComponent } from 'vue'

const BannerStatusStore = defineAsyncComponent(
    () => import('@/components/main/header/BannerStatusStore.vue')
)
const BannerWebMessageSpecial = defineAsyncComponent(
    () => import('@/components/main/header/BannerWebMessageSpecial.vue')
)
const Navbar = defineAsyncComponent(() => import('@/components/main/Navbar.vue'))

const { updateStore, storeData, testDay, testHour, testMinute } = useStoreInfo()

watchersHeader()
</script>

<template>
    <header :class="{ hidden: dataLoaded !== 2, block: dataLoaded === 2 }">
        <BannerStatusStore />
        <BannerWebMessageSpecial />
        <Navbar />
    </header>
</template>

<style scoped>
header {
    @apply w-full;
}

/* .section-header {
    @apply flex flex-col items-center;
    line-height: 1.5;
} */

/* .content-site {
    @apply min-h-screen flex flex-col;
} */

/* .animate-text {
    animation: slideText 10s ease-in-out infinite;
    will-change: transform;
} */

/* @keyframes slideText {
    0% {
        /* transform: translateX(100%); */
/* Commence en dehors de l'écran à droite
    } */

/* 40% {
    transform: translateX(0);


  }

  60% {
    transform: translateX(0);

  }

    40% {
        /* transform: translateX(0) scale(1); */
/* Atteint la position centrale avec un effet de grossissement
    }

    50% {
        /* transform: translateX(0) scale(1.2); */
/* Augmenter encore plus en taille
    }

    60% {
        /* transform: translateX(0) scale(1); */
/* Retour à une taille agrandie après 50%
    }

    70% {
        /* transform: translateX(0) scale(1.2); */
/* Un autre cycle de mise à l'échelle
    }

    80% {
        /* transform: translateX(0) scale(1); */
/* Encore un autre cycle 
    }

    100% {
        /* transform: translateX(-100%); */
/* Part vers la gauche
    }
}*/
</style>
